module.exports = __webpack_public_path__ + "static/media/403b.88aaaf05.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/Wizard/parts/images/new/403b.svg
// module id = 542
// module chunks = 0